import { useMemo } from 'react';

import { getAllEmployees, getLanguage, User } from 'store';
import { fetchEmployees } from 'services';
import { EmployeeStatus, Language } from 'enums';

import { useFetchSelector } from './use-fetch-selector';
import { useAppSelector } from './use-app-selector';

const getEmployeeName = ({ firstName, lastName, firstNameEn, lastNameEn }: User, language: string) =>
  language === Language.RU ? `${lastName} ${firstName}` : `${lastNameEn} ${firstNameEn}`;

const getEmployeeLabel = (employee: User, language: string) =>
  `${getEmployeeName(employee, language)} (${employee.login.toLowerCase()})`;

export const useEmployeeOptions = (employeeIDs?: number[], filterByEmploymentStatus: boolean = true) => {
  const employees = useFetchSelector(getAllEmployees, fetchEmployees);
  const language = useAppSelector(getLanguage);

  return useMemo(() => {
    let filteredEmployees = employeeIDs
      ? employees.filter(({ employeeID }) => employeeIDs.includes(employeeID))
      : employees;

    if (filterByEmploymentStatus) {
      filteredEmployees = filteredEmployees.filter(
        ({ employmentStatus }) =>
          employmentStatus === EmployeeStatus.Employee || employmentStatus === EmployeeStatus.Evaluation,
      );
    }

    return filteredEmployees
      .map((employee) => ({
        label: getEmployeeLabel(employee, language),
        value: employee.employeeID,
      }))
      .sort((a, b) => (a.label > b.label ? 1 : -1));
  }, [employeeIDs, employees, language, filterByEmploymentStatus]);
};
